import {
  useHeaderTitle,
  useHeaderBackNavigate,
} from "@Light/components/page/header/context";
import { useScaffold } from "@Light/scaffold";
import { BrokerTermsOfService } from "./BrokerTermsOfService";

export type OtherDocumentsProps = {};
export const OtherDocuments: React.FC<OtherDocumentsProps> = ({}) => {
  useHeaderTitle("Other documents");
  useHeaderBackNavigate("/account/documents/");

  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  return (
    <PageBody>
      <div className="pt-8">
        <BrokerTermsOfService />
      </div>
    </PageBody>
  );
};
